import { CHECK_ORDER, CHECK_ADDITIONAL } from './check_order';
import { Filters } from '../../_flux/constants/filter/filters';
import { getDefaultValueForFilter } from '../../_flux/helper/filters/get_default_value_for_filter';
import { checkFor } from './check_for';
import CatalogConfiguratorStore from '../../_flux/stores/catalog_configurator_store';

export function checkNextEmptyValueAvailable(changedFilter, productType) {
    const changedIndexInCheckOrder = CHECK_ORDER.indexOf(changedFilter);

    if (changedIndexInCheckOrder === -1) {
        return;
    }

    const catalogConfiguratorFilterValues = CatalogConfiguratorStore.getState().values;
    let nextToCheck;
    let selectedFilterValues = {};
    let changedFilterDefaultValue;

    // get the next logical input's name
    for (let i = changedIndexInCheckOrder + 1; i < CHECK_ORDER.length; ++i) {
        changedFilterDefaultValue = getDefaultValueForFilter(CHECK_ORDER[i]);
        if (catalogConfiguratorFilterValues[CHECK_ORDER[i]] === changedFilterDefaultValue ||
            CHECK_ORDER[i] === Filters.MANUFACTURER
        ) {
            nextToCheck = CHECK_ORDER[i];
            break;
        }
    }

    // get all the values of input which have been selected already
    for (let i = 0; i < CHECK_ORDER.length; ++i) {
        changedFilterDefaultValue = getDefaultValueForFilter(CHECK_ORDER[i]);
        if (catalogConfiguratorFilterValues[CHECK_ORDER[i]] !== changedFilterDefaultValue) {
            selectedFilterValues[CHECK_ORDER[i]] = catalogConfiguratorFilterValues[CHECK_ORDER[i]];
        }
    }

    for (let x = 0; x < CHECK_ADDITIONAL.length; ++x) {
        let additionalFilter = catalogConfiguratorFilterValues[CHECK_ADDITIONAL[x]];
        if (!!additionalFilter) {
            selectedFilterValues[CHECK_ADDITIONAL[x]] = catalogConfiguratorFilterValues[CHECK_ADDITIONAL[x]];
        }
    }

    if (nextToCheck) {
        checkFor(productType, selectedFilterValues, nextToCheck, changedFilter);
    }
}
